
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/samochody-dostawcze/[marka]/[model]",
      function () {
        return require("private-next-pages/samochody-dostawcze/[marka]/[model]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/samochody-dostawcze/[marka]/[model]"])
      });
    }
  